import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

interface EliminationMatch {
  phase: string;
  court: number;
  startTime: string;
  endTime: string;
  category: string;
  participants: string[];
  date: string;
}

export function useTournamentSchedule(eventId: string, category?: string | null, subcategory?: string | null) {
  const [eliminationMatches, setEliminationMatches] = useState<EliminationMatch[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchSchedule() {
      try {
        const { data, error } = await supabase
          .from('tournament_schedules')
          .select('schedule_data')
          .eq('tournament_id', eventId)
          .single();

        if (error) {
          console.error('Error fetching tournament schedule:', error);
          setLoading(false);
          return;
        }

        if (data && data.schedule_data) {
          const allMatches: EliminationMatch[] = [];
          
          // Construir el filtro completo combinando categoría y subcategoría
          const fullCategory = category && subcategory 
            ? `${category} ${subcategory}` 
            : category;
          
          // Extraer todos los individualMatches de todas las fechas
          for (const [date, dayData] of Object.entries(data.schedule_data as Record<string, any>)) {
            if (dayData.individualMatches && Array.isArray(dayData.individualMatches)) {
              dayData.individualMatches.forEach((match: any) => {
                // Filtrar por categoría completa si se proporciona
                if (!fullCategory || match.category === fullCategory) {
                  allMatches.push({
                    ...match,
                    date: date, // Agregar la fecha al objeto
                  });
                }
              });
            }
          }
          
          setEliminationMatches(allMatches);
        }
      } catch (err) {
        console.error('Exception fetching schedule:', err);
      } finally {
        setLoading(false);
      }
    }

    if (eventId) {
      fetchSchedule();
    }
  }, [eventId, category, subcategory]);

  return { eliminationMatches, loading };
}
